export enum ResourceType {
  Image = 'image',
  Video = 'video',
  Raw = 'raw',
}
